
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/background.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-background-demo-xflow-components-background-color","docs-xflow-components-background-demo-xflow-components-background-image","docs-xflow-components-background-demo-xflow-components-background-watermark"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/background.zh.md?type=demo')
};